export const routes = {
  DASHBOARD: '/',
  SIGN_IN: '/sign-in',
  CREATE_ACCOUNT: '/create-account',
} as const
